// Seguimiento automático de clientes (migración 20261018a_followups.sql). Textos y validaciones de la página «Seguimiento».

export const DEFAULT_SETTINGS = {
  enabled: false, require_approval: true, rule_lead: true, rule_quote: true, rule_rebook: false,
  lead_after_hours: 24, quote_after_days: 2, rebook_after_days: 30, max_touches: 2, daily_cap: 20
};

// Los mismos rangos que valida la base.
const RANGES = {
  lead_after_hours: [4, 168, 'Las horas para dar seguimiento a un lead van de 4 a 168.'],
  quote_after_days: [1, 14, 'Los días para dar seguimiento a una cotización van de 1 a 14.'],
  rebook_after_days: [7, 365, 'Los días para invitar a volver van de 7 a 365.'],
  max_touches: [1, 3, 'Los mensajes por caso van de 1 a 3.'],
  daily_cap: [1, 100, 'El tope diario va de 1 a 100 mensajes.']
};

export const normalizeSettings = (row) => ({ ...DEFAULT_SETTINGS, ...(row || {}) });

export const checkSettings = (values) => {
  for (const [key, [min, max, message]] of Object.entries(RANGES)) {
    const n = Number(values?.[key]);
    if (!Number.isInteger(n) || n < min || n > max) return message;
  }
  return null;
};

export const KIND_LABELS = { lead: 'Lead que se enfrió', cotizacion: 'Cotización sin respuesta', recompra: 'Volver a agendar' };
export const kindLabel = (f) => `${KIND_LABELS[f?.kind] || 'Seguimiento'}${Number(f?.touch) > 1 ? ` · mensaje ${f.touch}` : ''}`;

const STATUS = {
  redactar: { label: 'Redactando…', tone: 'text-amber-300' },
  redactando: { label: 'Redactando…', tone: 'text-amber-300' },
  por_aprobar: { label: 'Por aprobar', tone: 'text-fuchsia-300' },
  aprobado: { label: 'En cola para enviar', tone: 'text-amber-300' },
  enviando: { label: 'Enviando…', tone: 'text-amber-300' },
  enviado: { label: 'Enviado', tone: 'text-emerald-400' },
  error: { label: 'No se pudo enviar', tone: 'text-rose-300' },
  descartado: { label: 'Descartado', tone: 'text-seryi-text' },
  cancelado: { label: 'Cancelado', tone: 'text-seryi-text' }
};
export const followupStatus = (f) => STATUS[f?.status] || STATUS.cancelado;

// Qué se le va a decir y por qué, en una línea (sin precios: la base no los entrega).
export const contextLine = (f) => {
  const c = f?.context || {};
  if (f?.kind === 'cotizacion') return `Cotización ${c.numero || ''}${c.enviada ? ` enviada el ${c.enviada}` : ''}${c.lineas ? ` · ${c.lineas}` : ''}`.trim();
  if (f?.kind === 'recompra') return `${c.servicio || 'Servicio'}${c.fecha ? ` el ${c.fecha}` : ''}, sin cita posterior`;
  return c.mensajes_recibidos ? `Escribió ${c.mensajes_recibidos} veces y no agendó ni compró` : 'Escribió y no agendó ni compró';
};

export const MAX_DRAFT = 700;
export const checkDraft = (text) => {
  const t = String(text ?? '').trim();
  if (t.length < 10) return 'El mensaje es muy corto (mínimo 10 caracteres).';
  if (t.length > MAX_DRAFT) return `El mensaje puede tener hasta ${MAX_DRAFT} caracteres.`;
  return null;
};
